import { cn } from '@/lib/utils';
import { DIRECT_SALE_FONTS } from '@/config/direct-sale-fonts';
import { useDirectSaleTextStyle } from './useDirectSaleTextStyle';

/**
 * The drawer's content for "Schriftart": every Direct Sale font as a tall
 * tile, its name set in the font itself so the tile is its own preview.
 * The heading belongs to the drawer.
 *
 * Font names are proper nouns and stay untranslated.
 */
export function DirectSaleFontList() {
  const { isBound, fontFamily, setFont } = useDirectSaleTextStyle();

  return (
    <div className="grid grid-cols-2 gap-3">
      {DIRECT_SALE_FONTS.map((font) => {
        const active = isBound && font.fontFamily === fontFamily;
        return (
          <button
            key={font.label}
            type="button"
            aria-pressed={active}
            // Without a text there is nothing to set the font on.
            disabled={!isBound}
            onClick={() => void setFont(font.label)}
            className={cn(
              'flex min-h-[72px] min-w-0 items-center justify-center rounded-control px-4 py-4 text-center transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary disabled:cursor-not-allowed',
              active
                ? 'border-2 border-primary bg-primary-50'
                : 'border border-line bg-paper enabled:hover:bg-paper-2'
            )}
          >
            <span
              className="min-w-0 break-words text-[22px] leading-tight text-ink"
              style={{
                fontFamily: font.fontFamily,
                fontWeight: font.fontWeight,
              }}
            >
              {font.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
